import { Injectable, inject } from '@angular/core';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { environment } from '../../../../../../environments/environment';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { BranchNamemodel } from '../maintenance-branch-model/maintenance-branch-model';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceBranchService {
  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getBranchdetails() {
    const API_URL: string = environment.baseUrl + environment.apis.getBranchName;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.sessionStorageService.getCurrentUserAuthToken(),
      },
    };
    return await axios
      .request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewbranchDetails(repCode: string) {
    const API_URL: string = environment.baseUrl + environment.apis.viewBranchDetails;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.sessionStorageService.getCurrentUserAuthToken(),
      },
      data: {
        pias_rep_code: repCode,
        updated_by_role: ['DSU', 'DSU Manager']
      },
    };

    return await axios
      .request(REQUEST_CONFIG)
      .then((httpResource) => {
        return JSON.stringify(httpResource);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async savebranchDetails(BranchNamemodel: BranchNamemodel) {
    const API_URL: string = environment.baseUrl + environment.apis.saveBranchManagement ;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.sessionStorageService.getCurrentUserAuthToken(),
      },
      data: BranchNamemodel.getsavebranch(),
    };

    return await axios
      .request(REQUEST_CONFIG)
      .then((httpResource) => {
        return JSON.stringify(httpResource);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async saveBanding(repCode: string ,banding: string) {
    const API_URL: string = environment.baseUrl + environment.apis.saveBanding ;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.sessionStorageService.getCurrentUserAuthToken(),
      },
      data: {
        pias_rep_code: repCode,
        banding: banding,
      },
    };

    return await axios
      .request(REQUEST_CONFIG)
      .then((httpResource) => {
        return JSON.stringify(httpResource);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getdirector(branchid: number) {
    const API_URL: string = environment.baseUrl + environment.apis.getDirectors;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.sessionStorageService.getCurrentUserAuthToken(),
      },
      data: {
        branch_id: branchid,
      },
    };

    return await axios
      .request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async deletebranchRow(id: number) {
    const API_URL: string = environment.baseUrl + environment.apis.deleteBranchRow;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.sessionStorageService.getCurrentUserAuthToken(),
      },
      data: {
        id: id
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }
}


